import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import content from "@/content/siteContent";

export default function WhoWeServeSection() {
  const ch = content.chapters.whoWeServe;
  return (
    <section id={ch.id} data-testid="chapter-who-we-serve" className="relative mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHeader num={ch.num} label={ch.label} />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ch.segments.map((seg, i) => (
          <Reveal key={seg.num} delay={0.1 * i} className="h-full">
            <div
              data-testid={`serve-card-${i}`}
              className="group h-full rounded-2xl border border-plz-line/60 bg-plz-navy/40 p-7 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-plz-orange/50 hover:shadow-[0_16px_50px_rgba(65,105,225,0.12)]"
            >
              <span className="font-heading text-3xl font-extrabold text-plz-line transition-colors duration-500 group-hover:text-plz-orange">
                {seg.num}
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold">{seg.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-plz-slate">{seg.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
